import _ from 'lodash';

import {
  COMPANY_DEFAULT_MI_PROVIDER_OPTION,
  DEFAULT_MI_APPLICATION_TYPE_OPTION,
  miApplicationTypeSelectOptions,
} from './LoanActionMortgageInsuranceRow.constants';

export const getMiProviderOptions = ({ providerOptions, providerKey }) => {
  const isUnlistedProviderKey =
    !_.isNil(providerKey) && !providerOptions.some(({ value }) => value === providerKey);

  return [
    COMPANY_DEFAULT_MI_PROVIDER_OPTION,
    ...providerOptions,
    ...(isUnlistedProviderKey ? [{ name: providerKey, value: providerKey }] : []),
  ];
};

export const getSelectedMiProviderOption = ({ options, providerKey }) =>
  options.find(({ value }) => value === (providerKey ?? null)) ??
  COMPANY_DEFAULT_MI_PROVIDER_OPTION;

export const getSelectedMiApplicationTypeOption = applicationType =>
  miApplicationTypeSelectOptions.find(({ value }) => value === (applicationType?.value ?? null)) ??
  DEFAULT_MI_APPLICATION_TYPE_OPTION;
